import {useMemo} from "react";
import {useLocation} from "react-router";

import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {createBottomNavSections, createNavigationSections, INavigationSection} from "../config/navigation_sections";
import {isPathPrefixActive} from "../utils/is_path_prefix_active";

export const useNavigationSections = () => {
    const site = useMatchedSite();
    const location = useLocation();

    const sections = useMemo(() => createNavigationSections(site), [site]);
    const bottomNavSections = useMemo(() => createBottomNavSections(site), [site]);

    const activeSection: INavigationSection | undefined = sections.find((section) => isPathPrefixActive(location.pathname, section.path));

    return {
        activeSection,
        bottomNavSections,
        sections,
        site
    };
};
import {useMemo} from "react";
import {useLocation} from "react-router";

import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {createBottomNavSections, createNavigationSections, INavigationSection} from "../config/navigation_sections";
import {isPathPrefixActive} from "../utils/is_path_prefix_active";

export const useNavigationSections = () => {
    const site = useMatchedSite();
    const location = useLocation();

    const sections = useMemo(() => createNavigationSections(site), [site]);
    const bottomNavSections = useMemo(() => createBottomNavSections(site), [site]);

    const activeSection: INavigationSection | undefined = sections.find((section) => isPathPrefixActive(location.pathname, section.path));

    return {
        activeSection,
        bottomNavSections,
        sections,
        site
    };
};
